import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { addAgency } from "common/services/agencies.service";
import AgencyForm from "./AgencyForm";

const AddAgency: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchAgencies: () => void;
}> = ({ toggle, isModalOpen, fetchAgencies }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      category: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter agency name"),
      category: Yup.string(),
    }),
    onSubmit: async (values) => {
      const payload = {
        data: {
          name: values["name"],
          category: values["category"] || null,
        },
      };

      setLoading(true);
      try {
        await addAgency(payload);
        fetchAgencies();
        validation.resetForm();
        toggle();
        toast.success("Agency added successfully", {});
      } catch (error) {
        toast.error("Agency creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
      size="lg"
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Agency
      </ModalHeader>

      <AgencyForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddAgency;
